import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AlertController, IonInput } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-quantity',
  templateUrl: './quantity.component.html',
  styleUrl: './quantity.component.scss',
})
export class QuantityComponent implements OnInit {
  @Input() isBloc = false;
  @Input() isTrashVisible = false;
  @Input() noDraw = false;
  @Input() showTrash = false;
  @Input() showMaxMessage = false;
  @Input() message = '';
  @Input() quantity = 0;
  @Input() min = 0;
  @Input() max = 0;
  @Input() title = '';
  @Input() isVertical = false;
  @Input() isInput = false;
  @Input() onlyLimits = false;
  @Input() step = 1;
  @Input() disabled: boolean = false;

  @Output() quantityChange = new EventEmitter<number>();
  @Output() deleteItem = new EventEmitter<boolean>();

  constructor(private alertCtrl: AlertController, private translateS: TranslateService) {}

  ngOnInit(): void {}

  async sumQuantity(n: number) {
    if (this.disabled) return;
    if (this.onlyLimits) {
      if (n < 0) {
        this.quantity = this.min;
      } else {
        this.quantity = this.max;
      }
      this.quantityChange.emit(this.quantity); // Emitir el evento aquí
    } else {
      const result = this.quantity + n;

      if (result >= this.min && result <= this.max) {
        this.quantity = result;
        this.quantityChange.emit(result); // Emitir el evento aquí
      } else if (this.showTrash && result < this.min) {
        const alert = await this.alertCtrl.create({
          header: this.translateS.instant('¿Seguro de que quieres borrar este?', { item: this.title }),
          buttons: [
            'No',
            {
              text: 'Eliminar',
              handler: () => {
                if (!this.disabled) {
                  // Verificar disabled antes de emitir
                  this.deleteItem.emit(this.showTrash);
                }
              },
              cssClass: 'delete',
            },
          ],
          cssClass: 'alert',
        });

        await alert.present();
      } else if (result > this.max) {
        if (this.showMaxMessage) {
          const alert = await this.alertCtrl.create({
            header: this.message,
            buttons: ['Ok'],
            cssClass: 'alert',
          });

          await alert.present();
        }
        this.quantity = this.max;
        this.quantityChange.emit(this.max); // Emitir el evento aquí
      } else if (result < this.min) {
        this.quantity = this.min;
        this.quantityChange.emit(this.min); // Emitir el evento aquí
      }
    }
  }

  changeQuantityInput(ionInput: IonInput, ev: CustomEvent) {
    if (this.disabled) return;
    const regex = /^[0-9]+$/;
    let value = ev.detail.value;
    let deleteLetras = false;

    if (value === '') return;

    if (!regex.test(value)) {
      value = value.replace(/\D/g, '');
      deleteLetras = true;
    }

    if (+value !== this.quantity) {
      if (this.onlyLimits) {
        if (this.min >= +value) {
          this.quantity = this.min;
          ionInput.value = this.min;
        } else if (this.max <= +value) {
          this.quantity = this.max;
          ionInput.value = this.max;
        } else {
          ionInput.value = this.quantity;
        }
      } else {
        if (+value < this.min) {
          this.quantity = this.min;
          ionInput.value = this.min;
        } else if (+value > this.max) {
          this.quantity = this.max;
          ionInput.value = this.max;
        } else {
          this.quantity = +value;
          ionInput.value = +value;
        }
      }
      this.quantityChange.emit(this.quantity); // Emitir el evento aquí
    } else if (deleteLetras) {
      ionInput.value = +value;
      this.quantityChange.emit(this.quantity); // Emitir el evento aquí
    }
  }
}
